import { API } from "aws-amplify";
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable, { useRowSelect } from "react-table";
import 'react-table/react-table.css';
import Select from 'react-select';


export default class UserList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            users: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            user: null,
            locations: [{value: "onshore", label: "Onshore"}, {value: "offshore", label: "Offshore"}],
            selectedLocation: null,
            location: null,
            trustproof: null,
            dataSetPrimaryKey: "user_name"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    async componentDidMount() {
        console.log("In UserList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const users = await this.getUsers({
                                        userName: this.state.user,
                                        location: this.state.location,
                                        trustproof: this.state.trustproof
                                         });
            this.setState({ users });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {              
        this.setState({ users: [] });        
    }


    
    async getUsers(filter) {
        console.log("Inside getUsers() ");        
        return API.get("colin", "/users", {'queryStringParameters': filter});      
    }

    
    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let users = [...this.state.users];
        var r = window.confirm("Are you sure you want to delete this user?");
        if (r === true) {            
            users[cellInfo.index].archived_date = new Date();
            this.setState({users});
            await this.handleDataSave(users[cellInfo.index]).then((result) => {
                users.splice(cellInfo.index, 1);
                this.setState({users});
            });
            
        };
    };

    addRecord = async event => {
        let users = [...this.state.users];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        users.unshift({
            user_name: "",
            locations: "offshore",
            trust_proof: false,          
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({users});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/users/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/users/${record["user_name"]}`, {
            body: record
        });
        
        

       
    }

    

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

    handleLocationChange = (selectedLocation) => {
        
        if (selectedLocation) {
            this.setState({ selectedLocation, location: selectedLocation.value });          
        }
        else {
            this.setState({ selectedLocation: { value: null, label: null } });
            this.setState({ location: null });
            
        }
    }
   
    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const users = await this.getUsers( {
                            userName: this.state.user,
                            location: this.state.location,
                            trustproof: this.state.trustproof
                        });

        this.setState({ users });

        this.setState({ isLoading: false });
                
     }




    validateRecord(record) {

       
        // //Check street name not blank
        // if (record.suburb === "") {
        //     return [false,"Suburb cannot be blank. The record has not been saved"];
        // }
        // if (record.state === "") {
        //     return [false,"State cannot be blank. The record has not been saved"];
        // }
        // if (record.postcode === "") {
        //     return [false,"Postcode cannot be blank. The record has not been saved"];
        // }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let users = [...this.state.users];
        users[cellInfo.index][cellInfo.column.id] = event.target.value;
        users[cellInfo.index].modified = true;
        this.setState({users});
    };
    handleNumberChange = (cellInfo, event) => {
        let users = [...this.state.users];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        users[cellInfo.index][cellInfo.column.id] = Number(val);
        users[cellInfo.index].modified = true;
        this.setState({users});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let users = [...this.state.users];
        users[cellInfo.index][cellInfo.column.id] = event.target.checked;
        users[cellInfo.index].modified = true;
        this.setState({users});
    };

    handleDateChange = (cellInfo, event) => {
        let users = [...this.state.users];
        users[cellInfo.index][cellInfo.column.id] = new Date(event);
        users[cellInfo.index].modified = true;
        this.setState({users});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false, showWarning: false });
        let users = [...this.state.users];
        for (var i=0; i<users.length; i++){
            
            
            if (users[i].hasOwnProperty("modified")) {
                if (users[i].modified === true) {
                    console.log("Is modified");
                    const validation = this.validateRecord(users[i]);
                    if (validation[0] === true) {
                        console.log("Is valid");
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (users[i].hasOwnProperty("new_record")) {
                                if (users[i].new_record === true) {
                                    
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(users[i]);
                            if (result.result) {
                                users[i].modified = false;
                                if (users[i].hasOwnProperty("new_record")) {
                                    if (users[i].new_record === true) {

                                        users[i][this.state.dataSetPrimaryKey] = result.id;
                                        users[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    users[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (users[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
        }
    }
        }   
        if (users[0].hasOwnProperty("sort_order")) {
            users.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({users});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.users[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'user_name',
                Header: 'User Name',
                maxWidth: 150,
                accessor: 'user_name' ,
                Cell: this.renderEditable
                

        }
        , {
                id: 'locations',
                Header: 'Location',            
                accessor: 'locations',
                maxWidth: 150,
                Cell: this.renderEditable
                

            }, {
                id: 'trust_proof',
                Header: 'Trust Proof',            
                accessor: 'trust_proof',
                maxWidth: 50,
                Cell: this.renderEditable

            }
           ,
            {
                id: 'created_by',
                Header: 'Created By',
                maxWidth: 150,
                accessor: 'created_by'
            },
            {
                id: 'last_edited_by',
                Header: 'Last Edited By',
                maxWidth: 150,
                accessor: 'last_edited_by'
            },{
                Header: '',
                accessor: 'user_name',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="users">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            <Form.Group controlId="location">
                                <Select
                                    value={this.state.selectedLocation}
                                    onChange={this.handleLocationChange}
                                    options={this.state.locations}                                    
                                    placeholder="Location"  
                                    isClearable={true}                            
                                />


                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="trustproof">
                             <Form.Check checked={this.state.trustproof}
                                        onChange={this.handleCheckBoxChange}
                                        label="Trust Proof"
                                        type="checkbox"
                                        name="trustproof"
                                                                                
                                    />
                            
                            </Form.Group>
                        </Col>                        
                        <Col lg={2}>
                        <Button type="submit" className="float-left">Search</Button>
                        </Col>
                        
                       

                    </Form.Row>
                </Form>
                        
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.users) : this.renderTable(this.state.users)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="SuburbList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
